import styled from "styled-components";
import {
  colors,
  content,
  devicesNovo,
  marginsNovo,
} from "../../utils/styled/_variables.styled";
import { gridNovoConhecer } from "../../utils/styled/_grid.style";
import { createGlobalStyle } from "styled-components";

export const HeroGlobalStyles = createGlobalStyle`
  :where(body):not(:has(.custom-breadcrumb-wrapper)) .slick-slide img,
  :where(body):not(:has(.custom-breadcrumb-wrapper)) .slick-slide video {
    margin-top: 71px;
      
    @media (min-width: 992px) {
      margin-top: 100px;
    }
  }
`;

export const HeroContainer = styled.div`
  /* max-width: 1440px; */
  margin-left: auto;
  margin-right: auto;
  height: auto;

  /* @media ${devicesNovo.tablet} {
    height: 516px;
  }
  @media ${devicesNovo.mobile} {
    height: 512px;
  } */
  .content {
    position: relative;
    overflow: hidden;

    .slick-dots {
      width: 100%;
      max-width: ${content.desktop}px;
      bottom: 114px;
      text-align: left;
      margin: 0 auto;
      padding-left: ${marginsNovo.desktop}px;
      padding-right: ${marginsNovo.desktop}px;

      display: flex !important;
      flex-direction: row;
      gap: 8px;

      @media ${devicesNovo.tablet} {
        padding-left: ${marginsNovo.tablet}px;
        padding-right: ${marginsNovo.tablet}px;
        bottom: 66px;
        gap: 8px;
      }

      @media ${devicesNovo.mobile} {
        padding-left: ${marginsNovo.mobile}px;
        padding-right: ${marginsNovo.mobile}px;
        bottom: 60px;
      }
      .slick-active {
        background-color: ${colors.orange};
      }

      li {
        width: 80px;
        height: 2px;
        border-radius: 4px;
        background-color: ${colors.white};
        margin: unset;

        button {
          width: 80px;
          height: 10px;
        }
        @media ${devicesNovo.tablet} {
          width: 46px;
          button {
            width: 46px;
          }
        }

        @media ${devicesNovo.mobile} {
          width: 46px;
          button {
            width: 46px;
          }
        }
      }

      li > button:before {
        content: unset;
      }
    }
  }
`;

export const Slide = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;

  /* @media ${devicesNovo.tablet} {
    height: 516px;
  }
  @media ${devicesNovo.mobile} {
    height: 512px;
  } */

  a {
    user-select: none;
    -webkit-user-drag: none;
    width: 100%;
  }
  .hero__title {
    ${gridNovoConhecer("")}
    position: absolute;
    bottom: 116px;
    left: 0;
    color: ${colors.offwhite};
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;

    @media ${devicesNovo.tablet} {
      bottom: 68px;
    }
    @media ${devicesNovo.mobile} {
      bottom: 64px;
    }
  }

  h1, .heading-1 {
    font-size: 38px !important;
    font-weight: 900;
    max-width: 1149px;
    text-transform: uppercase;
    @media ${devicesNovo.desktop} and (max-width: 1250px) {
      line-height: 110%;
      font-size: 80px !important;
    }
    @media (min-width: 1250px) {
      line-height: 110px;
      font-size: 100px !important;
    }
  }

  img,
  video {
    height: auto;
    object-fit: cover;
    width: 100%;
    object-position: center center;
    aspect-ratio: 2732/1000;
    /* margin-top: 102px; */
    /* filter: brightness(0.6); */

    /* @media (max-width: 991px) {
      margin-top: 71px;
      height: 516px;
    } */

    @media ${devicesNovo.mobile} {
      aspect-ratio: 790/1000;
    }
  }
`;
